"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _propTypes = require("prop-types");

var _icons = require("../../../assets/icons");

var _Help = require("./Help.styles");

var Container = (0, _base["default"])("div", {
  target: "e16aexy70",
  label: "Container"
})(_Help.styles.helpStyle, ";");

var Help = function Help(_ref) {
  var className = _ref.className,
      validateStatus = _ref.validateStatus,
      help = _ref.help;
  return (0, _jsxRuntime.jsxs)(Container, {
    validateStatus: validateStatus,
    className: className,
    children: [validateStatus === 'success' ? (0, _jsxRuntime.jsx)(_icons.Valid, {}) : (0, _jsxRuntime.jsx)(_icons.Invalid, {}), (0, _jsxRuntime.jsx)("span", {
      children: help
    })]
  });
};

Help.propTypes = {
  className: _propTypes.string,
  validateStatus: (0, _propTypes.oneOf)(['success', 'error']),
  help: _propTypes.string
};
Help.defaultProps = {
  className: undefined,
  validateStatus: undefined,
  help: undefined
};
var _default = Help;
exports["default"] = _default;
//# sourceMappingURL=Help.js.map